export class LeaseVariables {
  employeeSignature = '';
  employeeName = '';
  lateDay = 5;
  lateNoGateAccess = 5;
  lateOverlock = 6;

  lateFee = '25.00';
  lateFeePercent = .1;
  lateFeeType: 'percent' | 'flat' = 'percent';
  lateFee2 = '25.00';
  lateFee2Percent = .1;
  lateFee2Type: 'percent' | 'flat' = 'percent';

  cutLockFee = '50.00';
  badCheckFee = '50.00';
  adminFee = '25.00';
  auctionFee = '50.00';

  billingType: 'anniversary' | 'static' = 'static';
  billingDueDay = 1;

  electricityYesText = "Yes";
  electricityNoText = "No";

  insuranceLocationId = '';
};



// WEBPACK FOOTER //
// ./src/ng2/app/models/lease-variables.ts